import React from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import RouteParameter from '../../components/RouteParameter';
import Layout from '../../features/Layout';

const DoctorVerifyEmail = React.lazy(() =>
  import('../../views/DoctorVerifyEmail')
);

const params = [];
const DoctorVerifyEmailRoute = () => {
  const location = useLocation();

  return (
    <RouteParameter location={location} params={params} fallback={null}>
      <Layout header={<></>} footer={<></>}>
        <DoctorVerifyEmail />
      </Layout>
    </RouteParameter>
  );
};

DoctorVerifyEmailRoute.propTypes = {};

DoctorVerifyEmailRoute.defaultProps = {};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(DoctorVerifyEmailRoute);
